"use client";

import { useEffect, useRef, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function ResidentialCommercial() {
  const courses = [{
    id: "residential",
    roman: "I",
    index: "I",
    label: "RESIDENTIAL",
    subtitle: "HOME SOLUTIONS",
    name: "Residential",
    accent: "Services",
    dishes: [{
      name: "Panel",
      accent: "Upgrades",
      price: "Call",
      desc: "Modernizing your home's electrical capacity for safety and efficiency",
      specialty: true
    }, {
      name: "Lighting",
      accent: "Design",
      price: "Call",
      desc: "Custom interior and exterior lighting installations for every room",
      specialty: false
    }, {
      name: "Smart",
      accent: "Home",
      price: "Call",
      desc: "Integration of automated systems, thermostats, and security",
      specialty: false
    }, {
      name: "Outlet",
      accent: "Wiring",
      price: "Call",
      desc: "Safe installation of GFCI and high-capacity charging stations",
      specialty: false
    }, {
      name: "Safety",
      accent: "Inspections",
      price: "Call",
      desc: "Comprehensive home electrical health checks and code compliance",
      specialty: true
    }, {
      name: "EV",
      accent: "Charging",
      price: "Call",
      desc: "Level 2 home charging station installation for electric vehicles",
      specialty: false
    }]
  }, {
    id: "commercial",
    roman: "II",
    index: "II",
    label: "COMMERCIAL",
    subtitle: "BUSINESS POWER",
    name: "Commercial",
    accent: "Solutions",
    dishes: [{
      name: "System",
      accent: "Design",
      price: "Call",
      desc: "Full-scale electrical planning for new construction and renovations",
      specialty: true
    }, {
      name: "Data",
      accent: "Cabling",
      price: "Call",
      desc: "Structured network wiring and server room power distribution",
      specialty: false
    }, {
      name: "Emergency",
      accent: "Lighting",
      price: "Call",
      desc: "Installation and maintenance of exit and backup lighting systems",
      specialty: false
    }, {
      name: "Energy",
      accent: "Audits",
      price: "Call",
      desc: "Optimizing power consumption to reduce operational overhead",
      specialty: false
    }, {
      name: "Maintenance",
      accent: "Contracts",
      price: "Call",
      desc: "Scheduled preventative care for business electrical infrastructure",
      specialty: false
    }, {
      name: "Industrial",
      accent: "Power",
      price: "Call",
      desc: "High-voltage equipment installation and heavy-duty circuitry",
      specialty: true
    }, {
      name: "Security",
      accent: "Systems",
      price: "Call",
      desc: "Hardwired surveillance and access control power integration",
      specialty: false
    }]
  }, {
    id: "emergency",
    roman: "III",
    index: "III",
    label: "EMERGENCY",
    subtitle: "RAPID RESPONSE",
    name: "Emergency",
    accent: "Repair",
    dishes: [{
      name: "Power",
      accent: "Outage",
      price: "24/7",
      desc: "Immediate troubleshooting and restoration of lost power",
      specialty: true
    }, {
      name: "Short",
      accent: "Circuit",
      price: "24/7",
      desc: "Locating and repairing dangerous electrical faults and shorts",
      specialty: false
    }, {
      name: "Panel",
      accent: "Failure",
      price: "24/7",
      desc: "Emergency replacement of burnt or malfunctioning breakers",
      specialty: false
    }, {
      name: "Storm",
      accent: "Damage",
      price: "24/7",
      desc: "Repairing downed lines and weather-related electrical hazards",
      specialty: false
    }, {
      name: "Hazard",
      accent: "Mitigation",
      price: "24/7",
      desc: "Securing exposed wiring and fire-risk electrical components",
      specialty: false
    }, {
      name: "Urgent",
      accent: "Diagnostics",
      price: "24/7",
      desc: "Rapid assessment of flickering lights or burning smells",
      specialty: false
    }]
  }, {
    id: "booking",
    roman: "IV",
    index: "IV",
    label: "BOOKING",
    subtitle: "GET STARTED",
    name: "Request",
    accent: "Service",
    dishes: [{
      name: "Consultation",
      accent: "Request",
      price: "Free",
      desc: "Schedule a professional site visit with our licensed team",
      specialty: true
    }, {
      name: "Service",
      accent: "Quote",
      price: "Free",
      desc: "Transparent pricing for all residential and commercial projects",
      specialty: false
    }, {
      name: "Project",
      accent: "Planning",
      price: "Free",
      desc: "Expert guidance for your upcoming electrical renovation",
      specialty: false
    }, {
      name: "Maintenance",
      accent: "Check",
      price: "Free",
      desc: "Sign up for our annual electrical safety membership",
      specialty: false
    }, {
      name: "Support",
      accent: "Inquiry",
      price: "Free",
      desc: "Get answers to your technical questions from our master electricians",
      specialty: false
    }]
  }];
  const [activeId, setActiveId] = useState("residential");
  const courseRefs = useRef<Record<string, HTMLDivElement | null>>({});
  useEffect(() => {
    const handler = () => {
      const offset = 200;
      let current = courses[0].id;
      for (const c of courses) {
        const el = courseRefs.current[c.id];
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= offset) current = c.id;
      }
      setActiveId(current);
    };
    window.addEventListener("scroll", handler, {
      passive: true
    });
    handler();
    return () => window.removeEventListener("scroll", handler);
  }, []);
  return <section data-section-id="1047" id="residential-commercial" className="bg-background text-foreground py-28 md:py-40 relative overflow-hidden text-center">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8">
        {}
        <div className="lg:hidden sticky top-16 z-30 -mx-5 px-5 py-3 bg-background/95 backdrop-blur-md border-b border-border mb-10">
          <div className="flex gap-3 overflow-x-auto no-scrollbar">
            {courses.map((c, i) => <Link key={c.id} data-index={i} to={`#${c.id}`} className={`shrink-0 font-mono text-xs tracking-[0.18em] uppercase px-3 py-1.5 border border-border text-foreground transition-colors duration-300 ${activeId === c.id ? "bg-primary text-primary-foreground border-primary" : "bg-transparent"}`}>
                {c.index}. {c.label}
              </Link>)}
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {}
          <aside className="hidden lg:block col-span-4">
            <div className="sticky top-[120px]">
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground mb-3">
                § 01 — OUR EXPERTISE / CURRENT PULSE
              </div>

              {}
              <div className="flex items-center gap-3 mb-8">
                <div className="h-px flex-1 bg-border" />
                <svg width="22" height="14" viewBox="0 0 22 14" fill="none" className="text-primary">
                  <path d="M1 7 Q 6 2, 11 7 T 21 7" stroke="currentColor" strokeWidth="1.25" fill="none" strokeLinecap="round" />
                  <ellipse cx="6" cy="4" rx="2" ry="1" stroke="currentColor" strokeWidth="1" fill="none" />
                  <ellipse cx="11" cy="3" rx="2" ry="1" stroke="currentColor" strokeWidth="1" fill="none" />
                  <ellipse cx="16" cy="4" rx="2" ry="1" stroke="currentColor" strokeWidth="1" fill="none" />
                </svg>
                <div className="h-px flex-1 bg-border" />
              </div>

              <div className="relative">
                <div aria-hidden="true" className="absolute -top-10 -left-4 font-serif italic text-primary select-none pointer-events-none" style={{
                fontSize: "clamp(8rem, 16vw, 14rem)",
                opacity: 0.08,
                lineHeight: 1
              }}>
                  I
                </div>
                <h2 className="relative font-serif font-normal text-foreground tracking-tight leading-[1.02]" style={{
                fontSize: "clamp(2.25rem, 4.6vw, 4rem)"
              }}>
                  Precision{" "}
                  <span className="italic text-primary">Electrical</span>{" "}
                  Solutions
                </h2>
              </div>

              <p className="mt-6 font-default text-base text-muted-foreground leading-[1.65] max-w-md">
                Professional electrical contracting services for residential, commercial, and emergency needs, delivered with safety and precision.
              </p>

              {}
              <nav className="mt-10 relative">
                <ul>
                  {courses.map((c, i) => <li key={c.id} data-index={i} className="border-t border-border last:border-b">
                      <Link to={`#${c.id}`} className="group flex items-center justify-between py-4 text-foreground">
                        <span className="flex items-center gap-4 font-mono text-sm tracking-[0.18em] uppercase">
                          <span className={`w-1.5 h-1.5 rounded-md transition-colors duration-300 ${activeId === c.id ? "bg-primary" : "bg-transparent border border-border"}`} />
                          <span className={activeId === c.id ? "text-primary" : ""}>
                            {c.index}. {c.label}
                          </span>
                        </span>
                        <span className="font-mono text-xs text-muted-foreground">
                          {String(c.dishes.length).padStart(2, "0")}
                        </span>
                      </Link>
                    </li>)}
                </ul>

                <div aria-hidden="true" className="mt-16 font-serif italic text-primary select-none pointer-events-none" style={{
                transform: "rotate(-4deg)",
                fontSize: "1.25rem"
              }}>
                  powering progress
                </div>
              </nav>
            </div>
          </aside>

          {}
          <div className="col-span-12 lg:col-span-8">
            {}
            <div className="lg:hidden mb-12">
              <div className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground mb-3">
                § 01 — OUR EXPERTISE / CURRENT PULSE
              </div>
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px flex-1 bg-border" />
                <span className="w-1 h-1 rounded-md bg-primary" />
                <div className="h-px flex-1 bg-border" />
              </div>
              <h2 className="font-serif font-normal text-foreground tracking-tight leading-[1.02]" style={{
              fontSize: "clamp(2.25rem, 8vw, 3rem)"
            }}>
                Precision{" "}
                <span className="italic text-primary">Electrical</span>{" "}
                Solutions
              </h2>
            </div>

            <div>
              {courses.map((course, i) => <div key={course.id} data-index={i} id={course.id} ref={el => {
              courseRefs.current[course.id] = el;
            }} className="relative pt-16 pb-20 first:pt-0">
                  {}
                  {i > 0 && <div className="absolute top-0 left-0 right-0 flex items-center gap-3">
                      <div className="h-px flex-1 bg-border" />
                      <svg width="26" height="14" viewBox="0 0 26 14" fill="none" className="text-primary shrink-0">
                        <path d="M1 7 Q 7 2, 13 7 T 25 7" stroke="currentColor" strokeWidth="1.25" fill="none" strokeLinecap="round" />
                        <ellipse cx="7" cy="4" rx="2.2" ry="1.1" stroke="currentColor" strokeWidth="1" fill="none" />
                        <ellipse cx="13" cy="3" rx="2.2" ry="1.1" stroke="currentColor" strokeWidth="1" fill="none" />
                        <ellipse cx="19" cy="4" rx="2.2" ry="1.1" stroke="currentColor" strokeWidth="1" fill="none" />
                      </svg>
                      <div className="h-px flex-1 bg-border" />
                    </div>}

                  {}
                  <div className="relative mb-10">
                    <div aria-hidden="true" className="absolute -top-10 -left-5 font-serif italic text-primary select-none pointer-events-none" style={{
                  fontSize: "clamp(7rem, 14vw, 12rem)",
                  opacity: 0.08,
                  lineHeight: 1
                }}>
                      {course.roman}
                    </div>
                    <div className="relative">
                      <div className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground mb-3">
                        § {course.roman} — {course.label} / {course.subtitle}
                      </div>
                      <h3 className="font-serif font-normal text-foreground tracking-tight leading-[1.05]" style={{
                    fontSize: "clamp(2rem, 4vw, 3.25rem)"
                  }}>
                        <span className="italic text-primary">{course.name}</span>
                      </h3>
                    </div>
                  </div>

                  {}
                  <ul className="space-y-0">
                    {course.dishes.map((dish, j) => <li key={`${course.id}-${j}`} data-index={j} className="py-6 border-t border-border last:border-b">
                        <div className="flex items-baseline gap-3">
                          <h4 className="font-serif font-medium text-foreground text-xl md:text-2xl tracking-tight leading-tight shrink-0">
                            {dish.name}{" "}
                            <span className="italic text-primary">{dish.accent}</span>
                          </h4>
                          <span className="flex-1 border-b border-dotted border-border self-end mb-1.5" aria-hidden="true" />
                          <span className="font-mono text-sm md:text-base text-foreground font-medium shrink-0">
                            {dish.price}
                          </span>
                        </div>
                        <div className="mt-2 flex items-center gap-3 flex-wrap">
                          <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                            {dish.desc}
                          </p>
                          {dish.specialty && <Badge variant="outline" className="font-mono text-[0.7rem] tracking-[0.12em] uppercase border-primary/40 bg-primary/10 text-primary px-2.5 py-0.5">
                              certified
                            </Badge>}
                        </div>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}